//@ts-nocheck
import { Badge } from 'react-bootstrap';
import { firstLetterToUpperCase } from 'services/utils/string';

export const formatDate = (dateString) => {
  return new Date(dateString).toLocaleDateString('pl-PL', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const getStatusBadge = (status) => {
  const statusConfig = {
    oczekuje: { variant: 'info', text: 'Oczekujące' },
    ['w realizacji']: { variant: 'primary', text: 'W realizacji' },
    odebrano: { variant: 'success', text: 'Odebrane' },
  };
  console.log(status);
  const config = statusConfig[status] || {
    variant: 'secondary',
    text: status,
  };
  return (
    <Badge bg={config.variant}>
      {firstLetterToUpperCase(config.text)}
    </Badge>
  );
};

export const calculateTotalValue = (items) => {
  if (!items) return 0;
  return items.reduce(
    (total, item) => total + item.quantity * item.unitPrice,
    0,
  );
};

export const calculateTotalItems = (items) => {
  if (!items) return 0;
  return items.reduce((total, item) => total + item.quantity, 0);
};

export const calculateReceivedTotalItems = (items) => {
  if (!items) return 0;
  return items.reduce(
    (total, item) => total + (item.receivedQuantity || 0),
    0,
  );
};

export const calculateReceivedTotalValue = (items) => {
  if (!items) return 0;
  return items.reduce((total, item) => {
    return (
      total + (item.receivedQuantity || 0) * (item.actualUnitPrice || 0)
    );
  }, 0);
};
